// Language dictionary for LOTTO WORLD lottery platform.
// Keys are grouped by area. Add new keys in all languages when introducing new strings.

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "ur", label: "اردو" },
  { code: "zh", label: "中文" },
  { code: "es", label: "Español" },
  { code: "ar", label: "العربية" },
  { code: "pt", label: "Português" },
  { code: "fr", label: "Français" },
];

export const RTL_LANGS = ["ur", "ar"];

const D = {
  en: {
    brand_region: "SINGAPORE · WORLDWIDE",
    live_pools: "LIVE POOLS · SINGAPORE",
    choose_line1: "Choose your",
    choose_line2: "level of chance.",
    live: "LIVE",
    my_tickets: "My tickets",
    control_room: "Control room",
    per_ticket: "per ticket",
    draw_date: "Draw date",
    countdown_days: "Days",
    countdown_hours: "Hours",
    countdown_minutes: "Minutes",
    countdown_seconds: "Seconds",
    draw_ready: "Draw ready",
    sold: "sold",
    total: "total",
    remaining: "remaining",
    buy_tickets: "Buy tickets",
    view_prizes: "See full prize breakdown",
    biggest_prize: "Top prize",
    home_note: "Each pool runs independently · Prizes are drawn from active ticket codes · All amounts in USD",
    welcome_back: "WELCOME BACK",
    join_network: "JOIN THE NETWORK",
    recovery_login: "RECOVERY LOGIN",
    recovery_vault: "RECOVERY VAULT",
    enter_draw: "Enter the draw",
    create_account: "Create your account",
    use_seed_phrase: "Use your seed phrase",
    seed_tagline: "A secure account for the global draw.",
    auth_hindi_note: "A secure account for the global draw.",
    email_or_mobile: "Email or mobile",
    password: "Password",
    name_label: "Name",
    name_ph: "Your full name",
    identifier_ph: "you@example.com",
    referral_code: "Referral code",
    optional: "optional",
    referral_ph: "Share code",
    seed_field_label: "12-word phrase",
    seed_field_ph: "word word word ...",
    continue_btn: "Continue",
    recover_account: "Recover account",
    create_btn: "Create account",
    use_seed_toggle: "Use 12-word recovery phrase",
    back_to_password: "Back to password login",
    new_here: "New here? Create account",
    already_registered: "Already registered? Log in",
    seed_h1: "Your phrase. Your access.",
    seed_desc: "Save this 12-word phrase somewhere private. It will only be shown once. You will need it if you ever forget your password.",
    seed_warn: "Copy and store your 12 words in a safe place. Then click the gold button below to continue to your account.",
    important: "Important:",
    copy_phrase: "Copy phrase",
    saved_continue: "I have saved my phrase — Continue",
    every_draw_1: "Every draw.",
    every_draw_2: "One clear chance.",
    every_draw_desc: "Independent prize pools, transparent draw dates, and a ticket trail you can trust.",
    provably_fair_note: "Provably fair draw system",
    check_login: "Please check your details and try again.",
    account_ledger: "ACCOUNT LEDGER",
    my_tickets_h1: "My tickets",
    back_to_pools: "Back to pools",
    your_referral_code: "Your referral code",
    referral_progress_title: "Referral rewards",
    referral_progress_sub: "Bring 5 referrals and earn 1 free $1 ticket",
    referral_reward_detail: "Every 5 successful referrals automatically unlock 1 free Tier 1 ticket.",
    free_ticket: "free ticket",
    share_invite: "Share invite",
    copy_link: "Copy link",
    copied: "Copied",
    signin_referral: "Sign in to get your referral link",
    friends_joined: "referrals",
    free_tickets_earned: "free tickets earned",
    to_next_free_ticket: "more to unlock your next free ticket",
    all_earned: "You just unlocked a free ticket! Keep sharing to earn more.",
    booked_tickets: "BOOKED TICKETS",
    total_count: "total",
    no_tickets: "No tickets yet. Your booked tickets will appear here.",
    tier_prefix: "Tier",
    prize_structure: "PRIZE STRUCTURE",
    pool_word: "Pool",
    total_prize_pool: "Total prize pool",
    prize_1: "1st Prize",
    prize_2: "2nd Prize",
    prize_3: "3rd Prize",
    prize_4_7: "4th – 7th Prize",
    prize_8_10: "8th – 10th Prize",
    winner: "winner",
    winners: "winners",
    each_suffix: "each",
    live_prize_line: "Every winning ticket is drawn live from the active pool. All amounts in USD.",
    reserve_tickets: "Reserve {name} tickets",
    quantity: "Quantity",
    checkout_total: "Total",
    review_and_pay: "Review & pay",
    proceed_to_payment: "Proceed to payment",
    back_btn: "Back",
    order_summary: "Order summary",
    tickets_word: "tickets",
    send_usdt_note: "Send USDT to the address below, then paste your transaction hash to reserve your tickets.",
    tx_hash_label: "Transaction hash",
    after_sending: "after sending",
    copy_address: "Copy address",
    confirm_reservation: "I sent USDT — reserve tickets",
    tickets_reserved: "Ticket codes generated",
    pending_confirmation: "Your ticket codes are pending payment approval. Live sold quantity updates only after approval.",
    done: "Done",
    control_room_eyebrow: "CONTROL ROOM",
    admin_console: "Admin console",
    admin_verified: "Admin verified",
    metric_users: "Registered users",
    metric_tickets: "Tickets sold",
    metric_revenue: "Revenue generated",
    metric_referrals: "Active referrals",
    draw_calendar: "DRAW CALENDAR",
    set_next_draw: "Set the next draw",
    draw_desc: "The date appears live beside each pool.",
    draw_date_input: "Draw date",
    save_date: "Save date",
    offline_sales: "OFFLINE SALES",
    issue_direct: "Issue direct tickets",
    offline_desc: "For cash purchases made at the office.",
    select_ticket_tier: "Select ticket tier",
    allotting: "Allotting...",
    customer_name: "Customer name",
    provably_fair: "PROVABLY FAIR DRAW",
    run_draw: "Run Tier {tier} draw",
    draw_transparency: "The seed and algorithm are published with the winners.",
    run_secure: "Run secure draw",
    could_not_order: "Could not create order",
    draw_unavailable: "Draw unavailable",
    logout_title: "Log out",
    pool_tag_1: "Starter Pick",
    pool_tag_2: "Fan Favourite",
    pool_tag_3: "Premium Play",
    pool_tag_4: "Mega Jackpot",
    sign_in: "Sign in",
    loading: "Loading LOTTO WORLD",
    payment_approvals: "PAYMENT APPROVALS",
    review_payments: "Review incoming payments",
    payments_desc: "Approve payments after checking the transaction on the blockchain. Rejecting will remove reserved tickets.",
    filter_pending: "Pending",
    filter_approved: "Approved",
    filter_rejected: "Rejected",
    filter_all: "All",
    no_payments: "No payments in this view.",
    tx_hash_short: "Tx",
    amount: "Amount",
    approve: "Approve",
    reject: "Reject",
    payment_pending: "Pending review",
    payment_approved: "Approved",
    payment_rejected: "Rejected",
    confirm_submit: "Confirm & Submit Payment",
    payment_step_note: "Once you send USDT, paste the transaction hash and click the gold button below.",
    tx_hash_required: "Please paste your transaction hash before submitting.",
  },
  hi: {
    brand_region: "सिंगापुर · विश्वव्यापी",
    live_pools: "लाइव पूल · सिंगापुर",
    choose_line1: "अपना",
    choose_line2: "मौका चुनिए।",
    live: "लाइव",
    my_tickets: "मेरे टिकट",
    control_room: "कंट्रोल रूम",
    per_ticket: "प्रति टिकट",
    draw_date: "ड्रॉ तारीख",
    countdown_days: "दिन",
    countdown_hours: "घंटे",
    countdown_minutes: "मिनट",
    countdown_seconds: "सेकंड",
    draw_ready: "ड्रॉ तैयार",
    sold: "बिके",
    total: "कुल",
    remaining: "बचे",
    buy_tickets: "टिकट खरीदें",
    view_prizes: "पूरा इनाम विवरण देखें",
    biggest_prize: "पहला इनाम",
    home_note: "हर पूल स्वतंत्र चलता है · सक्रिय टिकटों से इनाम निकाले जाते हैं · सभी राशि USD में",
    welcome_back: "वापसी पर स्वागत",
    join_network: "नेटवर्क से जुड़ें",
    recovery_login: "रिकवरी लॉगिन",
    recovery_vault: "रिकवरी वॉल्ट",
    enter_draw: "ड्रॉ में शामिल हों",
    create_account: "अपना खाता बनाएं",
    use_seed_phrase: "अपना सीड फ्रेज़ इस्तेमाल करें",
    seed_tagline: "वैश्विक ड्रॉ के लिए सुरक्षित खाता।",
    auth_hindi_note: "आपका सुरक्षित lottery account",
    email_or_mobile: "ईमेल या मोबाइल",
    password: "पासवर्ड",
    name_label: "नाम",
    name_ph: "आपका पूरा नाम",
    identifier_ph: "you@example.com",
    referral_code: "रेफरल कोड",
    optional: "वैकल्पिक",
    referral_ph: "कोड डालें",
    seed_field_label: "12-शब्दों का वाक्यांश",
    seed_field_ph: "शब्द शब्द शब्द ...",
    continue_btn: "आगे बढ़ें",
    recover_account: "खाता वापस पाएं",
    create_btn: "खाता बनाएं",
    use_seed_toggle: "12-शब्दों की रिकवरी फ्रेज़ इस्तेमाल करें",
    back_to_password: "पासवर्ड लॉगिन पर वापस",
    new_here: "नए हैं? खाता बनाएं",
    already_registered: "पहले से रजिस्टर्ड? लॉगिन करें",
    seed_h1: "आपका फ्रेज़। आपकी पहुँच।",
    seed_desc: "इन 12 शब्दों को कहीं सुरक्षित लिख कर रखें। ये सिर्फ एक बार दिखेगा। पासवर्ड भूलने पर यही काम आएगा।",
    seed_warn: "अपने 12 शब्द किसी सुरक्षित जगह कॉपी करके रखें। फिर नीचे सुनहरे बटन पर क्लिक करके अपने खाते में जाएँ।",
    important: "ज़रूरी:",
    copy_phrase: "फ्रेज़ कॉपी करें",
    saved_continue: "मैंने फ्रेज़ सेव कर लिया — आगे बढ़ें",
    every_draw_1: "हर ड्रॉ।",
    every_draw_2: "एक साफ मौका।",
    every_draw_desc: "स्वतंत्र इनाम पूल, पारदर्शी ड्रॉ तारीखें और भरोसेमंद टिकट रिकॉर्ड।",
    provably_fair_note: "प्रोवेबली फेयर ड्रॉ सिस्टम",
    check_login: "अपनी जानकारी जांच कर फिर कोशिश करें।",
    account_ledger: "खाता विवरण",
    my_tickets_h1: "मेरे टिकट",
    back_to_pools: "पूल पर वापस",
    your_referral_code: "आपका रेफरल कोड",
    referral_progress_title: "रेफरल इनाम",
    referral_progress_sub: "5 रेफरल लाएं, 1 मुफ्त $1 टिकट पाएं",
    referral_reward_detail: "हर 5 सफल रेफरल पर 1 मुफ्त टियर 1 टिकट अपने आप मिलता है।",
    free_ticket: "मुफ्त टिकट",
    share_invite: "निमंत्रण शेयर करें",
    copy_link: "लिंक कॉपी करें",
    copied: "कॉपी हो गया",
    signin_referral: "रेफरल लिंक पाने के लिए साइन इन करें",
    friends_joined: "रेफरल",
    free_tickets_earned: "मुफ्त टिकट कमाए",
    to_next_free_ticket: "और चाहिए अगले मुफ्त टिकट के लिए",
    all_earned: "बधाई! मुफ्त टिकट मिल गया। और शेयर करके और कमाएं।",
    booked_tickets: "बुक टिकट",
    total_count: "कुल",
    no_tickets: "अभी कोई टिकट नहीं। आपके खरीदे टिकट यहाँ दिखेंगे।",
    tier_prefix: "टियर",
    prize_structure: "इनाम संरचना",
    pool_word: "पूल",
    total_prize_pool: "कुल इनाम राशि",
    prize_1: "पहला इनाम",
    prize_2: "दूसरा इनाम",
    prize_3: "तीसरा इनाम",
    prize_4_7: "चौथा – सातवाँ इनाम",
    prize_8_10: "आठवाँ – दसवाँ इनाम",
    winner: "विजेता",
    winners: "विजेता",
    each_suffix: "प्रत्येक",
    live_prize_line: "हर जीतने वाला टिकट लाइव पूल से निकाला जाता है। सभी राशि USD में।",
    reserve_tickets: "{name} टिकट रिज़र्व करें",
    quantity: "मात्रा",
    checkout_total: "कुल",
    review_and_pay: "समीक्षा और भुगतान",
    proceed_to_payment: "भुगतान की ओर बढ़ें",
    back_btn: "वापस",
    order_summary: "ऑर्डर सारांश",
    tickets_word: "टिकट",
    send_usdt_note: "नीचे दिए पते पर USDT भेजें, फिर ट्रांज़ैक्शन हैश डालकर अपने टिकट रिज़र्व करें।",
    tx_hash_label: "ट्रांज़ैक्शन हैश",
    after_sending: "भेजने के बाद",
    copy_address: "पता कॉपी करें",
    confirm_reservation: "मैंने USDT भेज दिया — टिकट रिज़र्व करें",
    tickets_reserved: "टिकट कोड बन गए",
    pending_confirmation: "आपके टिकट कोड भुगतान मंजूरी के इंतज़ार में हैं। लाइव बिक्री संख्या मंजूरी के बाद ही बढ़ेगी।",
    done: "पूरा",
    control_room_eyebrow: "कंट्रोल रूम",
    admin_console: "एडमिन कंसोल",
    admin_verified: "एडमिन प्रमाणित",
    metric_users: "पंजीकृत उपयोगकर्ता",
    metric_tickets: "बिके टिकट",
    metric_revenue: "उत्पन्न राजस्व",
    metric_referrals: "सक्रिय रेफरल",
    draw_calendar: "ड्रॉ कैलेंडर",
    set_next_draw: "अगला ड्रॉ तय करें",
    draw_desc: "यह तारीख हर पूल के पास लाइव दिखेगी।",
    draw_date_input: "ड्रॉ तारीख",
    save_date: "तारीख सेव करें",
    offline_sales: "ऑफलाइन बिक्री",
    issue_direct: "सीधे टिकट जारी करें",
    offline_desc: "ऑफिस पर नकद खरीद के लिए।",
    select_ticket_tier: "टिकट टियर चुनें",
    allotting: "जारी हो रहा है...",
    customer_name: "ग्राहक का नाम",
    provably_fair: "प्रोवेबली फेयर ड्रॉ",
    run_draw: "टियर {tier} ड्रॉ चलाएं",
    draw_transparency: "सीड और एल्गोरिथ्म विजेताओं के साथ प्रकाशित होता है।",
    run_secure: "सुरक्षित ड्रॉ चलाएं",
    could_not_order: "ऑर्डर नहीं बन सका",
    draw_unavailable: "ड्रॉ उपलब्ध नहीं",
    logout_title: "लॉग आउट",
    pool_tag_1: "शुरुआती चुनाव",
    pool_tag_2: "पसंदीदा",
    pool_tag_3: "प्रीमियम",
    pool_tag_4: "मेगा जैकपॉट",
    sign_in: "साइन इन",
    loading: "LOTTO WORLD लोड हो रहा है",
    payment_approvals: "भुगतान अनुमोदन",
    review_payments: "आने वाले भुगतान की समीक्षा करें",
    payments_desc: "ब्लॉकचेन पर ट्रांज़ैक्शन जांच कर भुगतान अनुमोदित करें। अस्वीकार करने पर रिज़र्व टिकट हटा दिए जाएंगे।",
    filter_pending: "लंबित",
    filter_approved: "अनुमोदित",
    filter_rejected: "अस्वीकृत",
    filter_all: "सभी",
    no_payments: "इस दृश्य में कोई भुगतान नहीं।",
    tx_hash_short: "Tx",
    amount: "राशि",
    approve: "अनुमोदित करें",
    reject: "अस्वीकार करें",
    payment_pending: "समीक्षा लंबित",
    payment_approved: "अनुमोदित",
    payment_rejected: "अस्वीकृत",
    confirm_submit: "पुष्टि करें और भुगतान जमा करें",
    payment_step_note: "USDT भेजने के बाद, ट्रांज़ैक्शन हैश पेस्ट करें और नीचे सुनहरे बटन पर क्लिक करें।",
    tx_hash_required: "जमा करने से पहले ट्रांज़ैक्शन हैश पेस्ट करें।",
  },
  ur: {
    brand_region: "سنگاپور · دنیا بھر میں",
    live_pools: "لائیو پول · سنگاپور",
    choose_line1: "اپنی",
    choose_line2: "قسمت کا انتخاب کریں۔",
    live: "لائیو",
    my_tickets: "میرے ٹکٹ",
    control_room: "کنٹرول روم",
    per_ticket: "فی ٹکٹ",
    draw_date: "ڈرا کی تاریخ",
    countdown_days: "دن",
    countdown_hours: "گھنٹے",
    countdown_minutes: "منٹ",
    countdown_seconds: "سیکنڈ",
    draw_ready: "ڈرا تیار",
    sold: "فروخت",
    total: "کل",
    remaining: "باقی",
    buy_tickets: "ٹکٹ خریدیں",
    view_prizes: "مکمل انعامی تفصیل دیکھیں",
    biggest_prize: "پہلا انعام",
    home_note: "ہر پول آزادانہ چلتا ہے · فعال ٹکٹوں سے انعامات نکالے جاتے ہیں · تمام رقوم USD میں",
    welcome_back: "خوش آمدید",
    join_network: "نیٹ ورک میں شامل ہوں",
    recovery_login: "ریکوری لاگ ان",
    recovery_vault: "ریکوری والٹ",
    enter_draw: "ڈرا میں شامل ہوں",
    create_account: "اپنا اکاؤنٹ بنائیں",
    use_seed_phrase: "اپنا سیڈ فریز استعمال کریں",
    seed_tagline: "عالمی ڈرا کے لیے محفوظ اکاؤنٹ۔",
    auth_hindi_note: "عالمی ڈرا کے لیے محفوظ اکاؤنٹ۔",
    email_or_mobile: "ای میل یا موبائل",
    password: "پاس ورڈ",
    name_label: "نام",
    name_ph: "آپ کا پورا نام",
    identifier_ph: "you@example.com",
    referral_code: "ریفرل کوڈ",
    optional: "اختیاری",
    referral_ph: "کوڈ درج کریں",
    seed_field_label: "12 لفظی فریز",
    seed_field_ph: "لفظ لفظ لفظ ...",
    continue_btn: "جاری رکھیں",
    recover_account: "اکاؤنٹ بحال کریں",
    create_btn: "اکاؤنٹ بنائیں",
    use_seed_toggle: "12 لفظی ریکوری فریز استعمال کریں",
    back_to_password: "پاس ورڈ لاگ ان پر واپس",
    new_here: "نئے ہیں؟ اکاؤنٹ بنائیں",
    already_registered: "پہلے سے رجسٹرڈ؟ لاگ ان کریں",
    seed_h1: "آپ کا فریز۔ آپ کی رسائی۔",
    seed_desc: "ان 12 الفاظ کو کسی محفوظ جگہ محفوظ کریں۔ یہ صرف ایک بار دکھائے جائیں گے۔ پاس ورڈ بھول جانے پر یہی کام آئیں گے۔",
    seed_warn: "اپنے 12 الفاظ محفوظ جگہ پر کاپی کریں پھر نیچے سنہرے بٹن پر کلک کر کے اپنے اکاؤنٹ میں جائیں۔",
    important: "اہم:",
    copy_phrase: "فریز کاپی کریں",
    saved_continue: "میں نے فریز محفوظ کر لیا — جاری رکھیں",
    every_draw_1: "ہر ڈرا۔",
    every_draw_2: "ایک واضح موقع۔",
    every_draw_desc: "آزاد انعامی پول، شفاف ڈرا تواریخ اور قابلِ اعتماد ٹکٹ ریکارڈ۔",
    provably_fair_note: "پروویبلی فیئر ڈرا سسٹم",
    check_login: "اپنی تفصیلات چیک کر کے دوبارہ کوشش کریں۔",
    account_ledger: "اکاؤنٹ لیجر",
    my_tickets_h1: "میرے ٹکٹ",
    back_to_pools: "پول پر واپس",
    your_referral_code: "آپ کا ریفرل کوڈ",
    referral_progress_title: "ریفرل انعامات",
    referral_progress_sub: "5 ریفرلز لائیں اور 1 مفت $1 ٹکٹ حاصل کریں",
    referral_reward_detail: "ہر 5 کامیاب ریفرلز پر 1 مفت ٹیئر 1 ٹکٹ خودکار ملتا ہے۔",
    free_ticket: "مفت ٹکٹ",
    share_invite: "دعوت شیئر کریں",
    copy_link: "لنک کاپی کریں",
    copied: "کاپی ہوگیا",
    signin_referral: "ریفرل لنک کے لیے سائن ان کریں",
    friends_joined: "ریفرلز",
    free_tickets_earned: "مفت ٹکٹ کمائے",
    to_next_free_ticket: "اگلے مفت ٹکٹ کے لیے مزید درکار",
    all_earned: "مبارک! آپ نے مفت ٹکٹ حاصل کر لیا۔ مزید کمانے کے لیے شیئر کرتے رہیں۔",
    booked_tickets: "بک ٹکٹ",
    total_count: "کل",
    no_tickets: "ابھی کوئی ٹکٹ نہیں۔ آپ کے خریدے ٹکٹ یہاں نظر آئیں گے۔",
    tier_prefix: "ٹیئر",
    prize_structure: "انعامی ڈھانچہ",
    pool_word: "پول",
    total_prize_pool: "کل انعامی رقم",
    prize_1: "پہلا انعام",
    prize_2: "دوسرا انعام",
    prize_3: "تیسرا انعام",
    prize_4_7: "چوتھا – ساتواں انعام",
    prize_8_10: "آٹھواں – دسواں انعام",
    winner: "فاتح",
    winners: "فاتحین",
    each_suffix: "ہر ایک",
    live_prize_line: "ہر جیتنے والا ٹکٹ لائیو پول سے نکالا جاتا ہے۔ تمام رقوم USD میں۔",
    reserve_tickets: "{name} ٹکٹ ریزرو کریں",
    quantity: "مقدار",
    checkout_total: "کل",
    review_and_pay: "جائزہ اور ادائیگی",
    proceed_to_payment: "ادائیگی پر جائیں",
    back_btn: "واپس",
    order_summary: "آرڈر خلاصہ",
    tickets_word: "ٹکٹ",
    send_usdt_note: "نیچے دیے پتے پر USDT بھیجیں، پھر ٹرانزیکشن ہیش درج کر کے اپنے ٹکٹ ریزرو کریں۔",
    tx_hash_label: "ٹرانزیکشن ہیش",
    after_sending: "بھیجنے کے بعد",
    copy_address: "پتہ کاپی کریں",
    confirm_reservation: "میں نے USDT بھیج دیا — ٹکٹ ریزرو کریں",
    tickets_reserved: "ٹکٹ کوڈ بن گئے",
    pending_confirmation: "آپ کے ٹکٹ کوڈ ادائیگی کی منظوری کے منتظر ہیں۔ لائیو فروخت کی تعداد منظوری کے بعد بڑھے گی۔",
    done: "مکمل",
    control_room_eyebrow: "کنٹرول روم",
    admin_console: "ایڈمن کنسول",
    admin_verified: "ایڈمن تصدیق شدہ",
    metric_users: "رجسٹرڈ صارفین",
    metric_tickets: "فروخت شدہ ٹکٹ",
    metric_revenue: "پیدا شدہ آمدنی",
    metric_referrals: "فعال ریفرل",
    draw_calendar: "ڈرا کیلنڈر",
    set_next_draw: "اگلا ڈرا مقرر کریں",
    draw_desc: "تاریخ ہر پول کے پاس لائیو نظر آئے گی۔",
    draw_date_input: "ڈرا کی تاریخ",
    save_date: "تاریخ محفوظ کریں",
    offline_sales: "آف لائن سیل",
    issue_direct: "براہِ راست ٹکٹ جاری کریں",
    offline_desc: "دفتر پر نقد خریداری کے لیے۔",
    select_ticket_tier: "ٹکٹ ٹیئر منتخب کریں",
    allotting: "جاری کیا جا رہا ہے...",
    customer_name: "گاہک کا نام",
    provably_fair: "پروویبلی فیئر ڈرا",
    run_draw: "ٹیئر {tier} ڈرا چلائیں",
    draw_transparency: "سیڈ اور الگورتھم فاتحین کے ساتھ شائع کیے جاتے ہیں۔",
    run_secure: "محفوظ ڈرا چلائیں",
    could_not_order: "آرڈر نہیں بن سکا",
    draw_unavailable: "ڈرا دستیاب نہیں",
    logout_title: "لاگ آؤٹ",
    pool_tag_1: "ابتدائی انتخاب",
    pool_tag_2: "پسندیدہ",
    pool_tag_3: "پریمیم",
    pool_tag_4: "میگا جیک پاٹ",
    sign_in: "سائن ان",
    loading: "LOTTO WORLD لوڈ ہو رہا ہے",
    payment_approvals: "ادائیگی کی منظوری",
    review_payments: "آنے والی ادائیگیوں کا جائزہ",
    payments_desc: "بلاک چین پر ٹرانزیکشن چیک کر کے ادائیگی منظور کریں۔ رد کرنے پر محفوظ ٹکٹ ہٹا دیے جائیں گے۔",
    filter_pending: "زیرِ التوا",
    filter_approved: "منظور",
    filter_rejected: "مسترد",
    filter_all: "تمام",
    no_payments: "اس ویو میں کوئی ادائیگی نہیں۔",
    tx_hash_short: "Tx",
    amount: "رقم",
    approve: "منظور کریں",
    reject: "مسترد کریں",
    payment_pending: "جائزہ زیرِ التوا",
    payment_approved: "منظور",
    payment_rejected: "مسترد",
    confirm_submit: "تصدیق کریں اور ادائیگی جمع کریں",
    payment_step_note: "USDT بھیجنے کے بعد ٹرانزیکشن ہیش چسپاں کریں اور نیچے سنہرے بٹن پر کلک کریں۔",
    tx_hash_required: "جمع کرنے سے پہلے ٹرانزیکشن ہیش چسپاں کریں۔",
  },
  zh: {
    brand_region: "新加坡 · 全球",
    live_pools: "实时奖池 · 新加坡",
    choose_line1: "选择你的",
    choose_line2: "机会等级。",
    live: "实时",
    my_tickets: "我的票",
    control_room: "控制室",
    per_ticket: "每张",
    draw_date: "开奖日期",
    countdown_days: "天",
    countdown_hours: "小时",
    countdown_minutes: "分钟",
    countdown_seconds: "秒",
    draw_ready: "可开奖",
    sold: "已售",
    total: "总数",
    remaining: "剩余",
    buy_tickets: "购买彩票",
    view_prizes: "查看完整奖金结构",
    biggest_prize: "头奖",
    home_note: "每个奖池独立运行 · 从有效票中抽取 · 所有金额均为美元",
    welcome_back: "欢迎回来",
    join_network: "加入网络",
    recovery_login: "恢复登录",
    recovery_vault: "恢复保险库",
    enter_draw: "进入抽奖",
    create_account: "创建您的账户",
    use_seed_phrase: "使用您的助记词",
    seed_tagline: "全球抽奖的安全账户。",
    auth_hindi_note: "全球抽奖的安全账户。",
    email_or_mobile: "邮箱或手机",
    password: "密码",
    name_label: "姓名",
    name_ph: "您的全名",
    identifier_ph: "you@example.com",
    referral_code: "推荐码",
    optional: "可选",
    referral_ph: "分享码",
    seed_field_label: "12 个单词短语",
    seed_field_ph: "单词 单词 单词 ...",
    continue_btn: "继续",
    recover_account: "恢复账户",
    create_btn: "创建账户",
    use_seed_toggle: "使用 12 个单词恢复短语",
    back_to_password: "返回密码登录",
    new_here: "新用户？创建账户",
    already_registered: "已注册？登录",
    seed_h1: "您的短语，您的钥匙。",
    seed_desc: "请将这 12 个单词妥善保存。仅显示一次。忘记密码时需要用到。",
    seed_warn: "复制并将您的 12 个单词保存在安全的地方。然后点击下方的金色按钮进入您的账户。",
    important: "重要：",
    copy_phrase: "复制短语",
    saved_continue: "我已保存短语 — 继续",
    every_draw_1: "每一次开奖。",
    every_draw_2: "一个清晰的机会。",
    every_draw_desc: "独立的奖池、透明的开奖日期以及可信的票据记录。",
    provably_fair_note: "可证明的公平抽奖系统",
    check_login: "请检查您的信息并重试。",
    account_ledger: "账户明细",
    my_tickets_h1: "我的票",
    back_to_pools: "返回奖池",
    your_referral_code: "您的推荐码",
    referral_progress_title: "推荐奖励",
    referral_progress_sub: "完成 5 次推荐即可获得 1 张免费 $1 彩票",
    referral_reward_detail: "每 5 次成功推荐将自动解锁 1 张免费一级彩票。",
    free_ticket: "免费彩票",
    share_invite: "分享邀请",
    copy_link: "复制链接",
    copied: "已复制",
    signin_referral: "登录以获取推荐链接",
    friends_joined: "成功推荐",
    free_tickets_earned: "张免费彩票已获得",
    to_next_free_ticket: "位好友即可解锁下一张免费彩票",
    all_earned: "恭喜！您获得了一张免费彩票。继续分享获得更多。",
    booked_tickets: "已购彩票",
    total_count: "总数",
    no_tickets: "暂无彩票。您购买的彩票将显示在此。",
    tier_prefix: "级别",
    prize_structure: "奖金结构",
    pool_word: "奖池",
    total_prize_pool: "总奖池",
    prize_1: "一等奖",
    prize_2: "二等奖",
    prize_3: "三等奖",
    prize_4_7: "第 4 – 7 名",
    prize_8_10: "第 8 – 10 名",
    winner: "位赢家",
    winners: "位赢家",
    each_suffix: "每位",
    live_prize_line: "每张中奖彩票均从有效奖池实时抽取。所有金额均为美元。",
    reserve_tickets: "预订 {name} 彩票",
    quantity: "数量",
    checkout_total: "合计",
    review_and_pay: "确认并付款",
    proceed_to_payment: "进入付款",
    back_btn: "返回",
    order_summary: "订单摘要",
    tickets_word: "张",
    send_usdt_note: "请将 USDT 发送至下方地址，然后粘贴您的交易哈希以预订彩票。",
    tx_hash_label: "交易哈希",
    after_sending: "发送后",
    copy_address: "复制地址",
    confirm_reservation: "我已发送 USDT — 预订彩票",
    tickets_reserved: "彩票代码已生成",
    pending_confirmation: "您的彩票代码正在等待付款批准。实时售出数量仅在批准后更新。",
    done: "完成",
    control_room_eyebrow: "控制室",
    admin_console: "管理员控制台",
    admin_verified: "管理员已验证",
    metric_users: "注册用户",
    metric_tickets: "已售彩票",
    metric_revenue: "总收入",
    metric_referrals: "有效推荐",
    draw_calendar: "开奖日历",
    set_next_draw: "设置下次开奖",
    draw_desc: "日期将显示在每个奖池旁。",
    draw_date_input: "开奖日期",
    save_date: "保存日期",
    offline_sales: "线下销售",
    issue_direct: "直接发行彩票",
    offline_desc: "用于办公室现金购买。",
    select_ticket_tier: "选择彩票等级",
    allotting: "正在分配...",
    customer_name: "客户姓名",
    provably_fair: "可证明的公平抽奖",
    run_draw: "运行级别 {tier} 抽奖",
    draw_transparency: "种子和算法与获奖者一起公布。",
    run_secure: "运行安全抽奖",
    could_not_order: "无法创建订单",
    draw_unavailable: "抽奖不可用",
    logout_title: "退出登录",
    pool_tag_1: "入门之选",
    pool_tag_2: "人气之选",
    pool_tag_3: "高端玩法",
    pool_tag_4: "超级头奖",
    sign_in: "登录",
    loading: "LOTTO WORLD 加载中",
    payment_approvals: "付款审核",
    review_payments: "审核收到的付款",
    payments_desc: "在区块链上核实交易后批准付款。拒绝将撤销预留的彩票。",
    filter_pending: "待处理",
    filter_approved: "已批准",
    filter_rejected: "已拒绝",
    filter_all: "全部",
    no_payments: "此视图中没有付款。",
    tx_hash_short: "Tx",
    amount: "金额",
    approve: "批准",
    reject: "拒绝",
    payment_pending: "等待审核",
    payment_approved: "已批准",
    payment_rejected: "已拒绝",
    confirm_submit: "确认并提交付款",
    payment_step_note: "发送 USDT 后，粘贴交易哈希，然后点击下方金色按钮。",
    tx_hash_required: "提交前请粘贴您的交易哈希。",
  },
  es: {
    brand_region: "SINGAPUR · MUNDIAL",
    live_pools: "SORTEOS EN VIVO · SINGAPUR",
    choose_line1: "Elige tu",
    choose_line2: "nivel de suerte.",
    live: "EN VIVO",
    my_tickets: "Mis boletos",
    control_room: "Sala de control",
    per_ticket: "por boleto",
    draw_date: "Fecha del sorteo",
    countdown_days: "Días",
    countdown_hours: "Horas",
    countdown_minutes: "Minutos",
    countdown_seconds: "Segundos",
    draw_ready: "Sorteo listo",
    sold: "vendidos",
    total: "total",
    remaining: "restantes",
    buy_tickets: "Comprar boletos",
    view_prizes: "Ver desglose completo de premios",
    biggest_prize: "Primer premio",
    home_note: "Cada sorteo es independiente · Los premios se sortean de boletos activos · Todos los montos en USD",
    welcome_back: "BIENVENIDO DE NUEVO",
    join_network: "ÚNETE A LA RED",
    recovery_login: "INICIO DE RECUPERACIÓN",
    recovery_vault: "BÓVEDA DE RECUPERACIÓN",
    enter_draw: "Entrar al sorteo",
    create_account: "Crea tu cuenta",
    use_seed_phrase: "Usa tu frase semilla",
    seed_tagline: "Una cuenta segura para el sorteo global.",
    auth_hindi_note: "Una cuenta segura para el sorteo global.",
    email_or_mobile: "Correo o móvil",
    password: "Contraseña",
    name_label: "Nombre",
    name_ph: "Tu nombre completo",
    identifier_ph: "tu@ejemplo.com",
    referral_code: "Código de referido",
    optional: "opcional",
    referral_ph: "Compartir código",
    seed_field_label: "Frase de 12 palabras",
    seed_field_ph: "palabra palabra palabra ...",
    continue_btn: "Continuar",
    recover_account: "Recuperar cuenta",
    create_btn: "Crear cuenta",
    use_seed_toggle: "Usar frase de recuperación de 12 palabras",
    back_to_password: "Volver al inicio con contraseña",
    new_here: "¿Nuevo aquí? Crear cuenta",
    already_registered: "¿Ya registrado? Inicia sesión",
    seed_h1: "Tu frase. Tu acceso.",
    seed_desc: "Guarda estas 12 palabras en un lugar privado. Solo se muestran una vez. Las necesitarás si olvidas tu contraseña.",
    seed_warn: "Copia y guarda tus 12 palabras en un lugar seguro. Luego haz clic en el botón dorado para continuar a tu cuenta.",
    important: "Importante:",
    copy_phrase: "Copiar frase",
    saved_continue: "He guardado mi frase — Continuar",
    every_draw_1: "Cada sorteo.",
    every_draw_2: "Una oportunidad clara.",
    every_draw_desc: "Sorteos independientes, fechas transparentes y un historial de boletos en el que confiar.",
    provably_fair_note: "Sistema de sorteo demostrablemente justo",
    check_login: "Verifica tus datos e inténtalo de nuevo.",
    account_ledger: "REGISTRO DE CUENTA",
    my_tickets_h1: "Mis boletos",
    back_to_pools: "Volver a los sorteos",
    your_referral_code: "Tu código de referido",
    referral_progress_title: "Recompensas por referidos",
    referral_progress_sub: "Consigue 5 referidos y gana 1 boleto gratis de $1",
    referral_reward_detail: "Cada 5 referidos exitosos desbloquean automáticamente 1 boleto gratis de Nivel 1.",
    free_ticket: "boleto gratis",
    share_invite: "Compartir invitación",
    copy_link: "Copiar enlace",
    copied: "Copiado",
    signin_referral: "Inicia sesión para obtener tu enlace",
    friends_joined: "referidos",
    free_tickets_earned: "boletos gratis ganados",
    to_next_free_ticket: "más para desbloquear tu próximo boleto gratis",
    all_earned: "¡Desbloqueaste un boleto gratis! Sigue compartiendo para ganar más.",
    booked_tickets: "BOLETOS RESERVADOS",
    total_count: "total",
    no_tickets: "Aún no tienes boletos. Tus boletos aparecerán aquí.",
    tier_prefix: "Nivel",
    prize_structure: "ESTRUCTURA DE PREMIOS",
    pool_word: "Sorteo",
    total_prize_pool: "Total del bote",
    prize_1: "Primer premio",
    prize_2: "Segundo premio",
    prize_3: "Tercer premio",
    prize_4_7: "4to – 7mo premio",
    prize_8_10: "8vo – 10mo premio",
    winner: "ganador",
    winners: "ganadores",
    each_suffix: "cada uno",
    live_prize_line: "Cada boleto ganador se sortea en vivo del sorteo activo. Todos los montos en USD.",
    reserve_tickets: "Reservar boletos {name}",
    quantity: "Cantidad",
    checkout_total: "Total",
    review_and_pay: "Revisar y pagar",
    proceed_to_payment: "Ir al pago",
    back_btn: "Atrás",
    order_summary: "Resumen del pedido",
    tickets_word: "boletos",
    send_usdt_note: "Envía USDT a la dirección de abajo, luego pega tu hash de transacción para reservar tus boletos.",
    tx_hash_label: "Hash de transacción",
    after_sending: "después de enviar",
    copy_address: "Copiar dirección",
    confirm_reservation: "Envié USDT — reservar boletos",
    tickets_reserved: "Códigos de boleto generados",
    pending_confirmation: "Tus códigos esperan la aprobación del pago. La cantidad vendida se actualiza solo después de aprobarse.",
    done: "Listo",
    control_room_eyebrow: "SALA DE CONTROL",
    admin_console: "Consola de administrador",
    admin_verified: "Administrador verificado",
    metric_users: "Usuarios registrados",
    metric_tickets: "Boletos vendidos",
    metric_revenue: "Ingresos generados",
    metric_referrals: "Referidos activos",
    draw_calendar: "CALENDARIO DEL SORTEO",
    set_next_draw: "Fijar el próximo sorteo",
    draw_desc: "La fecha aparecerá en vivo junto a cada sorteo.",
    draw_date_input: "Fecha del sorteo",
    save_date: "Guardar fecha",
    offline_sales: "VENTAS OFFLINE",
    issue_direct: "Emitir boletos directos",
    offline_desc: "Para compras en efectivo en oficina.",
    select_ticket_tier: "Seleccionar nivel de boleto",
    allotting: "Asignando...",
    customer_name: "Nombre del cliente",
    provably_fair: "SORTEO DEMOSTRABLEMENTE JUSTO",
    run_draw: "Ejecutar sorteo Nivel {tier}",
    draw_transparency: "La semilla y el algoritmo se publican junto con los ganadores.",
    run_secure: "Ejecutar sorteo seguro",
    could_not_order: "No se pudo crear el pedido",
    draw_unavailable: "Sorteo no disponible",
    logout_title: "Cerrar sesión",
    pool_tag_1: "Nivel inicial",
    pool_tag_2: "Favorito",
    pool_tag_3: "Nivel Premium",
    pool_tag_4: "Mega Jackpot",
    sign_in: "Iniciar sesión",
    loading: "Cargando LOTTO WORLD",
  },
  ar: {
    brand_region: "سنغافورة · حول العالم",
    live_pools: "سحوبات مباشرة · سنغافورة",
    choose_line1: "اختر",
    choose_line2: "مستوى حظك.",
    live: "مباشر",
    my_tickets: "تذاكري",
    control_room: "غرفة التحكم",
    per_ticket: "لكل تذكرة",
    draw_date: "تاريخ السحب",
    countdown_days: "أيام",
    countdown_hours: "ساعات",
    countdown_minutes: "دقائق",
    countdown_seconds: "ثوانٍ",
    draw_ready: "السحب جاهز",
    sold: "مُباعة",
    total: "الإجمالي",
    remaining: "المتبقي",
    buy_tickets: "شراء التذاكر",
    view_prizes: "عرض تفاصيل الجوائز الكاملة",
    biggest_prize: "الجائزة الأولى",
    home_note: "يعمل كل سحب باستقلالية · تُسحب الجوائز من التذاكر الفعّالة · جميع المبالغ بالدولار الأمريكي",
    welcome_back: "مرحبًا بعودتك",
    join_network: "انضم إلى الشبكة",
    recovery_login: "تسجيل الاسترداد",
    recovery_vault: "خزنة الاسترداد",
    enter_draw: "ادخل السحب",
    create_account: "أنشئ حسابك",
    use_seed_phrase: "استخدم عبارة الأمان",
    seed_tagline: "حساب آمن للسحب العالمي.",
    auth_hindi_note: "حساب آمن للسحب العالمي.",
    email_or_mobile: "بريد إلكتروني أو هاتف",
    password: "كلمة المرور",
    name_label: "الاسم",
    name_ph: "اسمك الكامل",
    identifier_ph: "you@example.com",
    referral_code: "رمز الإحالة",
    optional: "اختياري",
    referral_ph: "أدخل الرمز",
    seed_field_label: "عبارة من 12 كلمة",
    seed_field_ph: "كلمة كلمة كلمة ...",
    continue_btn: "متابعة",
    recover_account: "استرداد الحساب",
    create_btn: "إنشاء حساب",
    use_seed_toggle: "استخدم عبارة الاسترداد المكوّنة من 12 كلمة",
    back_to_password: "العودة إلى تسجيل الدخول بكلمة المرور",
    new_here: "جديد هنا؟ أنشئ حسابًا",
    already_registered: "مسجل مسبقًا؟ تسجيل الدخول",
    seed_h1: "عبارتك. وصولك.",
    seed_desc: "احفظ هذه الكلمات الاثنتي عشرة في مكان آمن. ستظهر مرة واحدة فقط. ستحتاجها إذا نسيت كلمة المرور.",
    seed_warn: "انسخ الكلمات الاثنتي عشرة واحفظها في مكان آمن، ثم انقر على الزر الذهبي للمتابعة إلى حسابك.",
    important: "مهم:",
    copy_phrase: "نسخ العبارة",
    saved_continue: "لقد حفظت العبارة — متابعة",
    every_draw_1: "كل سحب.",
    every_draw_2: "فرصة واضحة واحدة.",
    every_draw_desc: "سحوبات مستقلة، تواريخ شفافة، وسجل تذاكر يمكنك الوثوق به.",
    provably_fair_note: "نظام سحب عادل قابل للإثبات",
    check_login: "يرجى التحقق من بياناتك والمحاولة مرة أخرى.",
    account_ledger: "دفتر الحساب",
    my_tickets_h1: "تذاكري",
    back_to_pools: "العودة إلى السحوبات",
    your_referral_code: "رمز الإحالة الخاص بك",
    referral_progress_title: "مكافآت الإحالة",
    referral_progress_sub: "أكمل 5 إحالات واربح تذكرة مجانية بقيمة $1",
    referral_reward_detail: "كل 5 إحالات ناجحة تفتح تلقائيًا تذكرة مجانية واحدة من المستوى الأول.",
    free_ticket: "تذكرة مجانية",
    share_invite: "مشاركة الدعوة",
    copy_link: "نسخ الرابط",
    copied: "تم النسخ",
    signin_referral: "سجل الدخول للحصول على رابط الإحالة",
    friends_joined: "إحالات",
    free_tickets_earned: "تذاكر مجانية مكتسبة",
    to_next_free_ticket: "المزيد لفتح تذكرتك المجانية التالية",
    all_earned: "مبروك! لقد ربحت تذكرة مجانية. تابع المشاركة لتربح المزيد.",
    booked_tickets: "التذاكر المحجوزة",
    total_count: "الإجمالي",
    no_tickets: "لا توجد تذاكر بعد. ستظهر تذاكرك المحجوزة هنا.",
    tier_prefix: "المستوى",
    prize_structure: "هيكل الجوائز",
    pool_word: "السحب",
    total_prize_pool: "مجموع الجوائز",
    prize_1: "الجائزة الأولى",
    prize_2: "الجائزة الثانية",
    prize_3: "الجائزة الثالثة",
    prize_4_7: "الجائزة الرابعة – السابعة",
    prize_8_10: "الجائزة الثامنة – العاشرة",
    winner: "فائز",
    winners: "فائزون",
    each_suffix: "لكل واحد",
    live_prize_line: "تُسحب كل تذكرة رابحة مباشرة من السحب النشط. جميع المبالغ بالدولار الأمريكي.",
    reserve_tickets: "احجز تذاكر {name}",
    quantity: "الكمية",
    checkout_total: "الإجمالي",
    review_and_pay: "مراجعة والدفع",
    proceed_to_payment: "المتابعة إلى الدفع",
    back_btn: "رجوع",
    order_summary: "ملخص الطلب",
    tickets_word: "تذاكر",
    send_usdt_note: "أرسل USDT إلى العنوان أدناه، ثم الصق تجزئة المعاملة لحجز تذاكرك.",
    tx_hash_label: "تجزئة المعاملة",
    after_sending: "بعد الإرسال",
    copy_address: "نسخ العنوان",
    confirm_reservation: "أرسلت USDT — احجز التذاكر",
    tickets_reserved: "تم إنشاء رموز التذاكر",
    pending_confirmation: "رموز تذاكرك بانتظار الموافقة على الدفع. يتحدث العدد المباع بعد الموافقة فقط.",
    done: "تم",
    control_room_eyebrow: "غرفة التحكم",
    admin_console: "لوحة المشرف",
    admin_verified: "مشرف موثّق",
    metric_users: "المستخدمون المسجلون",
    metric_tickets: "التذاكر المُباعة",
    metric_revenue: "الإيرادات",
    metric_referrals: "الإحالات النشطة",
    draw_calendar: "تقويم السحب",
    set_next_draw: "حدد السحب التالي",
    draw_desc: "يظهر التاريخ مباشرة بجانب كل سحب.",
    draw_date_input: "تاريخ السحب",
    save_date: "حفظ التاريخ",
    offline_sales: "المبيعات المكتبية",
    issue_direct: "إصدار تذاكر مباشرة",
    offline_desc: "للمشتريات النقدية في المكتب.",
    select_ticket_tier: "اختر مستوى التذكرة",
    allotting: "جارٍ التخصيص...",
    customer_name: "اسم العميل",
    provably_fair: "سحب عادل قابل للإثبات",
    run_draw: "تشغيل سحب المستوى {tier}",
    draw_transparency: "تُنشر البذرة والخوارزمية مع أسماء الفائزين.",
    run_secure: "تشغيل السحب الآمن",
    could_not_order: "تعذر إنشاء الطلب",
    draw_unavailable: "السحب غير متاح",
    logout_title: "تسجيل الخروج",
    pool_tag_1: "اختيار المبتدئين",
    pool_tag_2: "المفضل",
    pool_tag_3: "لعبة مميزة",
    pool_tag_4: "جائزة كبرى",
    sign_in: "تسجيل الدخول",
    loading: "جارٍ تحميل LOTTO WORLD",
  },
  pt: {
    brand_region: "SINGAPURA · MUNDIAL",
    live_pools: "SORTEIOS AO VIVO · SINGAPURA",
    choose_line1: "Escolha seu",
    choose_line2: "nível de sorte.",
    live: "AO VIVO",
    my_tickets: "Meus bilhetes",
    control_room: "Sala de controle",
    per_ticket: "por bilhete",
    draw_date: "Data do sorteio",
    countdown_days: "Dias",
    countdown_hours: "Horas",
    countdown_minutes: "Minutos",
    countdown_seconds: "Segundos",
    draw_ready: "Sorteio pronto",
    sold: "vendidos",
    total: "total",
    remaining: "restantes",
    buy_tickets: "Comprar bilhetes",
    view_prizes: "Ver detalhamento completo dos prêmios",
    biggest_prize: "Prêmio principal",
    home_note: "Cada sorteio é independente · Os prêmios são sorteados entre bilhetes ativos · Todos os valores em USD",
    welcome_back: "BEM-VINDO DE VOLTA",
    join_network: "JUNTE-SE À REDE",
    recovery_login: "LOGIN DE RECUPERAÇÃO",
    recovery_vault: "COFRE DE RECUPERAÇÃO",
    enter_draw: "Entrar no sorteio",
    create_account: "Crie sua conta",
    use_seed_phrase: "Use sua frase-semente",
    seed_tagline: "Uma conta segura para o sorteio global.",
    auth_hindi_note: "Uma conta segura para o sorteio global.",
    email_or_mobile: "E-mail ou celular",
    password: "Senha",
    name_label: "Nome",
    name_ph: "Seu nome completo",
    identifier_ph: "voce@exemplo.com",
    referral_code: "Código de indicação",
    optional: "opcional",
    referral_ph: "Código",
    seed_field_label: "Frase de 12 palavras",
    seed_field_ph: "palavra palavra palavra ...",
    continue_btn: "Continuar",
    recover_account: "Recuperar conta",
    create_btn: "Criar conta",
    use_seed_toggle: "Usar frase de 12 palavras",
    back_to_password: "Voltar ao login com senha",
    new_here: "Novo aqui? Criar conta",
    already_registered: "Já cadastrado? Entrar",
    seed_h1: "Sua frase. Seu acesso.",
    seed_desc: "Guarde estas 12 palavras em um local privado. Elas serão mostradas apenas uma vez. Você precisará delas se esquecer a senha.",
    seed_warn: "Copie e guarde suas 12 palavras em um lugar seguro. Depois clique no botão dourado para continuar até sua conta.",
    important: "Importante:",
    copy_phrase: "Copiar frase",
    saved_continue: "Guardei minha frase — Continuar",
    every_draw_1: "Cada sorteio.",
    every_draw_2: "Uma chance clara.",
    every_draw_desc: "Sorteios independentes, datas transparentes e um histórico de bilhetes confiável.",
    provably_fair_note: "Sistema de sorteio comprovadamente justo",
    check_login: "Verifique seus dados e tente novamente.",
    account_ledger: "REGISTRO DA CONTA",
    my_tickets_h1: "Meus bilhetes",
    back_to_pools: "Voltar aos sorteios",
    your_referral_code: "Seu código de indicação",
    referral_progress_title: "Recompensas por indicações",
    referral_progress_sub: "Consiga 5 indicações e ganhe 1 bilhete grátis de $1",
    referral_reward_detail: "A cada 5 indicações bem-sucedidas, 1 bilhete grátis do Nível 1 é liberado automaticamente.",
    free_ticket: "bilhete grátis",
    share_invite: "Compartilhar convite",
    copy_link: "Copiar link",
    copied: "Copiado",
    signin_referral: "Entre para obter seu link de indicação",
    friends_joined: "indicações",
    free_tickets_earned: "bilhetes grátis ganhos",
    to_next_free_ticket: "para desbloquear seu próximo bilhete grátis",
    all_earned: "Você desbloqueou um bilhete grátis! Continue compartilhando para ganhar mais.",
    booked_tickets: "BILHETES RESERVADOS",
    total_count: "total",
    no_tickets: "Ainda sem bilhetes. Seus bilhetes reservados aparecerão aqui.",
    tier_prefix: "Nível",
    prize_structure: "ESTRUTURA DE PRÊMIOS",
    pool_word: "Sorteio",
    total_prize_pool: "Prêmio total",
    prize_1: "Primeiro prêmio",
    prize_2: "Segundo prêmio",
    prize_3: "Terceiro prêmio",
    prize_4_7: "4º – 7º prêmio",
    prize_8_10: "8º – 10º prêmio",
    winner: "vencedor",
    winners: "vencedores",
    each_suffix: "cada",
    live_prize_line: "Cada bilhete premiado é sorteado ao vivo do sorteio ativo. Todos os valores em USD.",
    reserve_tickets: "Reservar bilhetes {name}",
    quantity: "Quantidade",
    checkout_total: "Total",
    review_and_pay: "Revisar e pagar",
    proceed_to_payment: "Ir para pagamento",
    back_btn: "Voltar",
    order_summary: "Resumo do pedido",
    tickets_word: "bilhetes",
    send_usdt_note: "Envie USDT para o endereço abaixo, depois cole seu hash de transação para reservar seus bilhetes.",
    tx_hash_label: "Hash da transação",
    after_sending: "após enviar",
    copy_address: "Copiar endereço",
    confirm_reservation: "Enviei USDT — reservar bilhetes",
    tickets_reserved: "Códigos de bilhete gerados",
    pending_confirmation: "Seus códigos aguardam aprovação do pagamento. A quantidade vendida só muda após a aprovação.",
    done: "Concluído",
    control_room_eyebrow: "SALA DE CONTROLE",
    admin_console: "Console do administrador",
    admin_verified: "Administrador verificado",
    metric_users: "Usuários cadastrados",
    metric_tickets: "Bilhetes vendidos",
    metric_revenue: "Receita gerada",
    metric_referrals: "Indicações ativas",
    draw_calendar: "CALENDÁRIO DO SORTEIO",
    set_next_draw: "Definir o próximo sorteio",
    draw_desc: "A data aparece ao vivo ao lado de cada sorteio.",
    draw_date_input: "Data do sorteio",
    save_date: "Salvar data",
    offline_sales: "VENDAS PRESENCIAIS",
    issue_direct: "Emitir bilhetes diretos",
    offline_desc: "Para compras em dinheiro no escritório.",
    select_ticket_tier: "Selecionar nível do bilhete",
    allotting: "Atribuindo...",
    customer_name: "Nome do cliente",
    provably_fair: "SORTEIO COMPROVADAMENTE JUSTO",
    run_draw: "Executar sorteio Nível {tier}",
    draw_transparency: "A semente e o algoritmo são publicados com os vencedores.",
    run_secure: "Executar sorteio seguro",
    could_not_order: "Não foi possível criar o pedido",
    draw_unavailable: "Sorteio indisponível",
    logout_title: "Sair",
    pool_tag_1: "Nível inicial",
    pool_tag_2: "Favorito",
    pool_tag_3: "Jogo Premium",
    pool_tag_4: "Mega Jackpot",
    sign_in: "Entrar",
    loading: "Carregando LOTTO WORLD",
  },
  fr: {
    brand_region: "SINGAPOUR · MONDIAL",
    live_pools: "TIRAGES EN DIRECT · SINGAPOUR",
    choose_line1: "Choisissez votre",
    choose_line2: "niveau de chance.",
    live: "EN DIRECT",
    my_tickets: "Mes billets",
    control_room: "Salle de contrôle",
    per_ticket: "par billet",
    draw_date: "Date du tirage",
    countdown_days: "Jours",
    countdown_hours: "Heures",
    countdown_minutes: "Minutes",
    countdown_seconds: "Secondes",
    draw_ready: "Tirage prêt",
    sold: "vendus",
    total: "total",
    remaining: "restants",
    buy_tickets: "Acheter des billets",
    view_prizes: "Voir la répartition complète des prix",
    biggest_prize: "Premier prix",
    home_note: "Chaque tirage est indépendant · Les prix sont tirés parmi les billets actifs · Tous les montants en USD",
    welcome_back: "BON RETOUR",
    join_network: "REJOIGNEZ LE RÉSEAU",
    recovery_login: "CONNEXION DE RÉCUPÉRATION",
    recovery_vault: "COFFRE DE RÉCUPÉRATION",
    enter_draw: "Entrer dans le tirage",
    create_account: "Créez votre compte",
    use_seed_phrase: "Utilisez votre phrase de récupération",
    seed_tagline: "Un compte sûr pour le tirage mondial.",
    auth_hindi_note: "Un compte sûr pour le tirage mondial.",
    email_or_mobile: "E-mail ou mobile",
    password: "Mot de passe",
    name_label: "Nom",
    name_ph: "Votre nom complet",
    identifier_ph: "vous@exemple.com",
    referral_code: "Code de parrainage",
    optional: "facultatif",
    referral_ph: "Code",
    seed_field_label: "Phrase de 12 mots",
    seed_field_ph: "mot mot mot ...",
    continue_btn: "Continuer",
    recover_account: "Récupérer le compte",
    create_btn: "Créer un compte",
    use_seed_toggle: "Utiliser la phrase de récupération de 12 mots",
    back_to_password: "Retour à la connexion par mot de passe",
    new_here: "Nouveau ici ? Créer un compte",
    already_registered: "Déjà inscrit ? Se connecter",
    seed_h1: "Votre phrase. Votre accès.",
    seed_desc: "Conservez ces 12 mots en lieu sûr. Ils ne seront affichés qu'une seule fois. Vous en aurez besoin si vous oubliez votre mot de passe.",
    seed_warn: "Copiez et rangez vos 12 mots en lieu sûr. Puis cliquez sur le bouton doré pour accéder à votre compte.",
    important: "Important :",
    copy_phrase: "Copier la phrase",
    saved_continue: "J'ai sauvegardé ma phrase — Continuer",
    every_draw_1: "Chaque tirage.",
    every_draw_2: "Une chance claire.",
    every_draw_desc: "Tirages indépendants, dates transparentes et un historique de billets fiable.",
    provably_fair_note: "Système de tirage vérifiablement équitable",
    check_login: "Vérifiez vos informations et réessayez.",
    account_ledger: "LIVRE DE COMPTE",
    my_tickets_h1: "Mes billets",
    back_to_pools: "Retour aux tirages",
    your_referral_code: "Votre code de parrainage",
    referral_progress_title: "Récompenses de parrainage",
    referral_progress_sub: "Obtenez 5 parrainages et gagnez 1 billet gratuit à $1",
    referral_reward_detail: "Tous les 5 parrainages réussis débloquent automatiquement 1 billet gratuit de niveau 1.",
    free_ticket: "billet gratuit",
    share_invite: "Partager l’invitation",
    copy_link: "Copier le lien",
    copied: "Copié",
    signin_referral: "Connectez-vous pour obtenir votre lien",
    friends_joined: "parrainages",
    free_tickets_earned: "billets gratuits gagnés",
    to_next_free_ticket: "de plus pour débloquer votre prochain billet gratuit",
    all_earned: "Vous avez débloqué un billet gratuit ! Continuez à partager pour en gagner plus.",
    booked_tickets: "BILLETS RÉSERVÉS",
    total_count: "total",
    no_tickets: "Aucun billet pour l'instant. Vos billets réservés apparaîtront ici.",
    tier_prefix: "Niveau",
    prize_structure: "STRUCTURE DES PRIX",
    pool_word: "Tirage",
    total_prize_pool: "Cagnotte totale",
    prize_1: "Premier prix",
    prize_2: "Deuxième prix",
    prize_3: "Troisième prix",
    prize_4_7: "4e – 7e prix",
    prize_8_10: "8e – 10e prix",
    winner: "gagnant",
    winners: "gagnants",
    each_suffix: "chacun",
    live_prize_line: "Chaque billet gagnant est tiré en direct du tirage actif. Tous les montants en USD.",
    reserve_tickets: "Réserver les billets {name}",
    quantity: "Quantité",
    checkout_total: "Total",
    review_and_pay: "Vérifier et payer",
    proceed_to_payment: "Passer au paiement",
    back_btn: "Retour",
    order_summary: "Récapitulatif de commande",
    tickets_word: "billets",
    send_usdt_note: "Envoyez des USDT à l'adresse ci-dessous, puis collez votre hash de transaction pour réserver vos billets.",
    tx_hash_label: "Hash de transaction",
    after_sending: "après envoi",
    copy_address: "Copier l'adresse",
    confirm_reservation: "J'ai envoyé USDT — réserver les billets",
    tickets_reserved: "Codes de billets générés",
    pending_confirmation: "Vos codes attendent l’approbation du paiement. Le nombre vendu ne change qu’après approbation.",
    done: "Terminé",
    control_room_eyebrow: "SALLE DE CONTRÔLE",
    admin_console: "Console administrateur",
    admin_verified: "Administrateur vérifié",
    metric_users: "Utilisateurs inscrits",
    metric_tickets: "Billets vendus",
    metric_revenue: "Revenus générés",
    metric_referrals: "Parrainages actifs",
    draw_calendar: "CALENDRIER DES TIRAGES",
    set_next_draw: "Fixer le prochain tirage",
    draw_desc: "La date apparaît en direct à côté de chaque tirage.",
    draw_date_input: "Date du tirage",
    save_date: "Enregistrer la date",
    offline_sales: "VENTES HORS-LIGNE",
    issue_direct: "Émettre des billets directs",
    offline_desc: "Pour les achats en espèces au bureau.",
    select_ticket_tier: "Choisir le niveau du billet",
    allotting: "Attribution...",
    customer_name: "Nom du client",
    provably_fair: "TIRAGE VÉRIFIABLEMENT ÉQUITABLE",
    run_draw: "Lancer le tirage Niveau {tier}",
    draw_transparency: "La graine et l'algorithme sont publiés avec les gagnants.",
    run_secure: "Lancer le tirage sécurisé",
    could_not_order: "Impossible de créer la commande",
    draw_unavailable: "Tirage indisponible",
    logout_title: "Se déconnecter",
    pool_tag_1: "Choix débutant",
    pool_tag_2: "Coup de cœur",
    pool_tag_3: "Jeu premium",
    pool_tag_4: "Méga Jackpot",
    sign_in: "Se connecter",
    loading: "Chargement de LOTTO WORLD",
  },
};

export const t = (lang, key, vars = {}) => {
  const dict = D[lang] || D.en;
  let str = dict[key] ?? D.en[key] ?? key;
  Object.entries(vars).forEach(([k, v]) => { str = str.replaceAll(`{${k}}`, v); });
  return str;
};
